import { Component, OnChanges, Input,  } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ProductService } from 'src/app/services/api/product.service';
import { WinService } from 'src/app/services/win.service';

@Component({
	selector: 'app-product-icon',
	templateUrl: './product-icon.component.html',
	styleUrls: ['./product-icon.component.scss']
})
export class ProductIconComponent implements OnChanges {

	@Input() product: any = null;
	@Input() bg: any = null;

	iconContent: any = null;
	iconContentSmall: any = null;

	constructor(
		public productService: ProductService,
		public winService: WinService,
		public sanitizer: DomSanitizer
	) { }

	ngOnChanges(): void {
		this.iconContent = "";
		this.iconContentSmall = "";
		this.product.custom_attributes.forEach(ca => {
			if(ca.attribute_code == 'entrelabel_product_icon'){
				this.iconContent = this.sanitizer.bypassSecurityTrustHtml(ca.value);
			}
			if(ca.attribute_code == 'entrelabel_product_icon_small'){
				this.iconContentSmall = this.sanitizer.bypassSecurityTrustHtml(ca.value);
			}	
		});
	}
}
